import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
    minHeight: 20,
    maxHeight: 20,
    minWidth: '100%',
    [theme.breakpoints.up("sm")]: {
      maxHeight: 1,
      display: 'none'
    },
  },
}))

function MobileBlankSpace(props){
  const classes = useStyles()

  return(
      <div className={classes.root}>
      </div>
  )
}
export default MobileBlankSpace
